module.exports = __webpack_public_path__ + "static/img/brand-2.e6cb40e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brand-2.svg
// module id = tYNe
// module chunks = 0